import React from 'react';
import { Result } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { LoginButton } from '../../components/auth';

const Login: React.FC = () => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      background: '#f5f5f5'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        maxWidth: '400px',
        width: '100%'
      }}>
        <Result
          icon={<LockOutlined />}
          title="Authentication Required"
          subTitle="Please log in to access this page."
          extra={<LoginButton />}
        />
      </div>
    </div>
  );
};

export default Login; 